module.exports = __webpack_public_path__ + "img/current-cashflow.8b753d4e.svg";